"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndexNearest = void 0;
var getIndexNearest = function (dataPointGroup, cursorX, cursorY) {
    var deltas = dataPointGroup[0].map(function (it) { return Math.abs(it[0] - (cursorX || 0)); });
    var min = Math.min.apply(Math, deltas);
    var indexX = deltas.indexOf(min);
    var nearestX = dataPointGroup[0][indexX];
    var indexY = dataPointGroup.map(function (it) { return it[indexX]; }).map(function (it) { return (cursorY || 0) > it[1]; }).indexOf(true);
    var nearestY = indexY >= 0 ? dataPointGroup[indexY][indexX] : 0;
    return { indexX: indexX, nearestX: nearestX, indexY: indexY, nearestY: nearestY };
};
exports.getIndexNearest = getIndexNearest;
